// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3Iuln","footer":"ModalError_footer__1WZPp"};